import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

/* Horizontal underline tabs (port of the design prototype's Tabs). */
export default function Tabs({ tabs, active, onChange, right }) {
  return (
    <div
      className="flex items-center gap-1 mb-rec"
      style={{ borderBottom: "1px solid var(--border)" }}
    >
      {tabs.map((tb) => {
        const on = active === tb.id;
        return (
          <button
            key={tb.id}
            type="button"
            onClick={() => onChange(tb.id)}
            className="relative inline-flex items-center gap-[7px] bg-transparent border-0 cursor-pointer font-sans text-[14px] font-semibold"
            style={{
              padding: "11px 14px",
              color: on ? "var(--accent-deep)" : "var(--ink-3)",
              lineHeight: "normal",
            }}
          >
            {tb.icon && <Icon name={tb.icon} style={{ fontSize: 18 }} />}
            {tb.label}
            {on && (
              <span
                className="absolute"
                style={{
                  left: 8,
                  right: 8,
                  bottom: -1,
                  height: 2.5,
                  borderRadius: 2,
                  background: "var(--accent)",
                }}
              />
            )}
          </button>
        );
      })}
      {right && <div className="ml-auto">{right}</div>}
    </div>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  right: PropTypes.node,
};

Tabs.defaultProps = {
  right: null,
};
